'use client'

import { useState, type ReactNode } from 'react'

type CollapsibleCategoryBlockProps = {
  categoryName: string
  itemCount: number
  /** Label setelah angka, mis. "produk" atau "orang". Default: produk */
  itemCountLabel?: string
  defaultOpen?: boolean
  children: ReactNode
  summary?: ReactNode
}

export function CollapsibleCategoryBlock({
  categoryName,
  itemCount,
  itemCountLabel = 'produk',
  defaultOpen = false,
  children,
  summary,
}: CollapsibleCategoryBlockProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="border border-outline-variant rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full px-3 py-2.5 bg-surface-container text-left min-h-[44px]"
        aria-expanded={open}
      >
        <div className="flex items-start gap-2">
          <span className="material-symbols-outlined text-lg text-on-surface-variant shrink-0 mt-0.5">
            {open ? 'expand_less' : 'expand_more'}
          </span>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <span className="text-body-sm font-semibold text-on-surface break-words">
                {categoryName}
              </span>
              {summary ? (
                <span className="text-label-md text-on-surface-variant shrink-0 text-right">
                  {summary}
                </span>
              ) : null}
            </div>
            <p className="text-label-md text-on-surface-variant mt-0.5">
              {itemCount} {itemCountLabel}
            </p>
          </div>
        </div>
      </button>
      {open ? <div className="border-t border-outline-variant">{children}</div> : null}
    </div>
  )
}
